const type = {
  FETCHCAMERAS: "FETCHCAMERAS",
  ADDCAMERA: "ADDCAMERA",
  EDITCAMERA: "EDITCAMERA",
  DELETECAMERA: "DELETECAMERA",
};

export default type;
